<div class="language-switcher" role="group" [attr.aria-label]="i18n.messages().languageSwitcher.label">
  @for (option of options; track option.locale) {
  <button type="button" class="language-switcher__option"
    [class.language-switcher__option--selected]="i18n.locale() === option.locale"
    [attr.aria-pressed]="i18n.locale() === option.locale" [attr.lang]="option.locale"
    (click)="onSelect(option.locale)">
    {{ option.label }}
  </button>
  }
</div>
